export default class RoutingRuleRequest {
  constructor(params) {
    this.routingRule = {
      da_prefix: params.da_prefix,
      account_id: params.account_id,
      network_id: params.network_id,
      gateway_id: params.gateway_id,
      product: params.product,
      routing_group: params.routing_group,
      network_prefix: params.network_prefix,
      all: params.all,
      page: params.page,
      pageSize: params.pageSize,
    }
    return this.routingRule
  }
}
